import { render, staticRenderFns } from "./ParksDetail.vue?vue&type=template&id=22ca7380&scoped=true&"
import script from "./ParksDetail.vue?vue&type=script&lang=js&"
export * from "./ParksDetail.vue?vue&type=script&lang=js&"
import style0 from "./ParksDetail.vue?vue&type=style&index=0&id=22ca7380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca7380",
  null
  
)

export default component.exports